<div class="wrapper" *ngIf="videoId && apiLoaded"
    style="max-width: {{width ? width + 'px' : 'auto'}}; max-height: {{height ? height + 'px' : 'auto'}}; {{style || ''}}">
  <youtube-player
    [videoId]="videoId" [width]="width" [height]="height" [playerVars]="playerVars"
    (stateChange)="onStateChange($event)"
    (playbackRateChange)="onPlaybackRateChange($event)"
    (error)="onError($event)"
  ></youtube-player>
</div>
